export default __webpack_public_path__ + "static/media/133.066edb5c.png";